import './view-container.scss';

import * as gzViewContainerDirective from './view-container.directive';

export default angular.module('gazelle.components.viewContainer', [
])
  .directive(gzViewContainerDirective.name, gzViewContainerDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/view-container/view-container.module.js